import React, { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthService from '@/services/AuthService';

const GuestMiddleware: FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isLoggedIn = AuthService.isLoggedIn();
  const redirectPath = AuthService.getRedirect();

  if (isLoggedIn) {
    // Agar redirect destination aur current path same hain → loop break
    if (location.pathname === redirectPath) {
      return <>{children}</>; 
    }

    return (
      <Navigate
        to={redirectPath}
        replace
        state={{ from: location }}
      />
    );
  }

  return <>{children}</>;
};

export default GuestMiddleware;
